export interface IState {
	result: IResult
	filters: IFilter[]
	query: string
	showFilter: boolean,
	showSearch: boolean,
	heading: IHeading,
	title: string,
	endpoints: {
		searchUrl: string
	},
	date: IDateRange
}

export interface IHeading {
	headingLevel: number
	selectorText: string
}

export interface IFilter {
	name: string
	amount: number
	current: boolean
}

export interface IResult {
	hits: IHit[]
	total: number
	amount: number
	filterAmount: []
}

export interface IDateRange {
    start: any
    end: any
}

export interface IRangeConfig {
    start: {
        timeAdjust: string
    }
    end: {
        timeAdjust: string
    }
}

export interface IHit {
	title: string
	uri: string
	ticketUrl: string
	date: {
		year: string
		month: string
		day: string
	}
	preamble: string
	image: string
	labels: []
	price: boolean
}

const deafultState: IState = {
	result: {
		hits: [],
		total: 0,
		amount: 0,
		filterAmount: []
	},
	showSearch: false,
	showFilter: false,
	title: '',
	heading: {
		headingLevel: 0,
		selectorText: ''
	},
	filters: [],
	query: '',
	endpoints: {
		searchUrl: '',
	},
	date: { start: undefined, end: undefined }
}

export default deafultState;